import React from 'react';
import moment from 'moment';

import ParsedHtml from 'buyside/components/presentation/ParsedHtml/parsedHtml';
import SubmitResearchButton from 'buyside/components/presentation/Button/SubmitResearchButton/submitResearchButton';

import styles from 'buyside/components/presentation/ContestShowPage/ContestDescription/contestDescriptionStyles.scss';

const ContestDescription = ({ contest, canWriteIdeas }) => {
  const { id, name, startDate, endDate, summary, active } = contest;
  return (
    <React.Fragment>
      <header className={styles.contestDescriptionHeader}>
        <div className={styles.headerWithButton}>
          <h2>{name}</h2>
          {canWriteIdeas && active && <SubmitResearchButton text="Enter Contest" />}
        </div>
        <div className={styles.contestDescriptionSubHeader}>
          <strong>Contest #{id}:</strong> {moment(startDate).format('MM/DD/YYYY')} -{' '}
          {moment(endDate).format('MM/DD/YYYY')}
        </div>
      </header>
      <ParsedHtml html={summary}>{({ content }) => <main>{content}</main>}</ParsedHtml>
    </React.Fragment>
  );
};

export default ContestDescription;
